export const assetKeys = {
  all: ["assets"] as const,
  lists: () => [...assetKeys.all, "list"] as const,
  detail: (id: string) => [...assetKeys.all, "detail", id] as const,
  reservations: () => [...assetKeys.all, "reservations"] as const,
  reservationsByAsset: (assetId: string) =>
    [...assetKeys.all, "reservations", "byAsset", assetId] as const,
  available: (startDate: string, endDate: string) =>
    [...assetKeys.all, "available", startDate, endDate] as const,
} as const;
